import React from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent } from '@ionic/react';
import SummaryContent from '../components/SummaryContent';

const Summary: React.FC = () => (
  <IonPage>
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton menu="main-menu" />
        </IonButtons>
        <IonTitle>Summary</IonTitle>
      </IonToolbar>
    </IonHeader>
    <IonContent fullscreen className="bg-gray-50 dark:bg-gray-900">
      <SummaryContent />
    </IonContent>
  </IonPage>
);

export default Summary;
